var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconRecenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 206.396,
    height: 206.396,
    viewBox: "0 0 206.396 206.396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 206.396,
    height: 206.396,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "recenter-icon",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M106.209,69.939a3.66,3.66,0,0,0-6.807-.028L74.187,132.964a3.659,3.659,0,0,0,5.9,4.031l19.962-18.668a3.661,3.661,0,0,1,5.032.03L125.1,137.543a3.659,3.659,0,0,0,5.94-3.972Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M198.9,95.7h-9.458A87.29,87.29,0,0,0,110.7,16.329V7.5a7.5,7.5,0,0,0-15,0v8.723A87.288,87.288,0,0,0,15.776,95.7H7.5a7.5,7.5,0,0,0,0,15h8.294a87.289,87.289,0,0,0,79.9,79.274V198.9a7.5,7.5,0,0,0,15,0v-9.029A87.291,87.291,0,0,0,189.42,110.7H198.9a7.5,7.5,0,0,0,0-15M110.7,174.78v-1.328a7.5,7.5,0,1,0-15,0v1.455A72.269,72.269,0,0,1,30.862,110.7h2.082a7.5,7.5,0,1,0,0-15H30.836A72.272,72.272,0,0,1,95.7,31.288v1.655a7.5,7.5,0,0,0,15,0V31.415A72.276,72.276,0,0,1,174.378,95.7h-.926a7.5,7.5,0,1,0,0,15h.9A72.272,72.272,0,0,1,110.7,174.78",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecenter);
export default __webpack_public_path__ + "static/media/icon-recenter.a2c9122cee444823b47ad86687face0a.svg";
export { ForwardRef as ReactComponent };